import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight, FaPlay, FaPause } from 'react-icons/fa';
import useScrollAnimation from './useScrollAnimation';

const highlightsData = [
  {
    id: 1,
    tag: '5G Flagship',
    title: 'Peace i18 PRO (5G)',
    description: '6.61" FHD+ 120Hz Immersive Vision with ultra-fast 5G connectivity and 20MP AI camera.',
    image: '/Photo/i17-pro-hero.png',
    badge: '120Hz FHD+ • 5G'
  },
  {
    id: 2,
    tag: 'Photography Mastery',
    title: 'Peace NOVA 18 PRO',
    description: '50MP Rear Ultra Clarity sensor with 8MP selfie camera and 6.56" HD+ display.',
    image: '/Photo/nova-17-pro-hero.jpg',
    badge: '50MP Clarity'
  },
  {
    id: 3,
    tag: 'Built-in Stylus',
    title: 'Peace SC26 (Aura26)',
    description: 'Precision built-in stylus pen for notes and sketch, paired with 5000 mAh endurance.',
    image: '/Photo/sc26-hero.jpg',
    badge: 'Stylus Included'
  },
  {
    id: 4,
    tag: 'Peace Care',
    title: '1 Year Warranty',
    description: '1 Year manufacturer warranty on every device for complete peace of mind.',
    image: '/Photo/sc26-hero.jpg',
    badge: '1 Year Coverage'
  }
];

const HighlightsSection = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.15 });
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  // Auto slide ticker
  React.useEffect(() => {
    if (!isPlaying) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % highlightsData.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [isPlaying]);

  return (
    <section 
      ref={sectionRef} 
      className={`highlights-section ${isVisible ? 'is-visible' : ''}`}
      id="highlights"
    >
      <div className="section-container">
        {/* Section Header */}
        <div className="section-header-row scroll-fade-up">
          <div>
            <span className="section-eyebrow">Highlights</span>
            <h2 className="section-headline">At a Glance.</h2>
          </div>
          <div className="section-header-action">
            <Link to="/products" className="apple-text-link">
              Compare all models <FaChevronRight className="link-arrow" />
            </Link>
          </div>
        </div>

        {/* Interactive Main Highlight Feature Card */}
        <div className="highlight-main-stage scroll-scale-up">
          <div className="highlight-card-backdrop">
            <img 
              src={highlightsData[activeIndex].image} 
              alt={highlightsData[activeIndex].title}
              className="highlight-feature-img"
            />
            <div className="highlight-gradient-overlay" />
          </div>

          <div className="highlight-content-box">
            <span className="highlight-badge-pill">
              {highlightsData[activeIndex].badge}
            </span>
            <span className="highlight-category">
              {highlightsData[activeIndex].tag}
            </span>
            <h3 className="highlight-card-title">
              {highlightsData[activeIndex].title}
            </h3>
            <p className="highlight-card-desc">
              {highlightsData[activeIndex].description}
            </p>
          </div>

          {/* Media Play / Pause Toggle */}
          <button 
            className="highlight-play-toggle"
            onClick={() => setIsPlaying(!isPlaying)}
            aria-label={isPlaying ? "Pause carousel" : "Play carousel"}
          >
            {isPlaying ? <FaPause /> : <FaPlay />}
          </button>
        </div>

        {/* Interactive Indicator Pills */}
        <div className="highlight-nav-pills scroll-fade-up">
          {highlightsData.map((item, idx) => (
            <button
              key={item.id}
              onClick={() => {
                setActiveIndex(idx);
                setIsPlaying(false);
              }}
              className={`highlight-nav-item ${activeIndex === idx ? 'active' : ''}`}
            >
              <div className="pill-progress-bar">
                <div 
                  className={`pill-fill ${activeIndex === idx && isPlaying ? 'animating' : ''}`} 
                />
              </div>
              <span className="pill-title">{item.title}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
